var _templateObject, _templateObject2;
function cov_1ezktp0oo() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Loader/HomeLoader.tsx";
  var hash = "6e48d23ead1f8f7c4437bd863a58f446c485f6e4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Loader/HomeLoader.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 26
        },
        end: {
          line: 11,
          column: 30
        }
      },
      "1": {
        start: {
          line: 13,
          column: 22
        },
        end: {
          line: 13,
          column: 26
        }
      },
      "2": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 14,
          column: 22
        }
      },
      "3": {
        start: {
          line: 15,
          column: 27
        },
        end: {
          line: 15,
          column: 30
        }
      },
      "4": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 28
        }
      },
      "5": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "6": {
        start: {
          line: 29,
          column: 18
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "7": {
        start: {
          line: 44,
          column: 29
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "8": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 68,
          column: 8
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 44,
            column: 29
          },
          end: {
            line: 44,
            column: 30
          }
        },
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 68,
            column: 8
          }
        },
        line: 45
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6e48d23ead1f8f7c4437bd863a58f446c485f6e4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ezktp0oo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ezktp0oo();
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable react/no-unknown-property */

/** @jsx jsx */
import React from 'react';
import { css, jsx, keyframes } from '@emotion/react';
import { colors } from "../../theme/eero/index.mjs";

// set `stroke-dashoffset` to a large value so that it starts offscreen
const OFF_SCREEN_OFFSET = (cov_1ezktp0oo().s[0]++, 1000);
// set `stroke-dasharray` to a large value so that we have a solid stroke
const SINGLE_STROKE = (cov_1ezktp0oo().s[1]++, 1000);
const STROKE_WIDTH = (cov_1ezktp0oo().s[2]++, 8);
const ANIMATION_DURATION = (cov_1ezktp0oo().s[3]++, 2.5);
// note: if you update this you will likely need to update the keyframe
// percentages in `drawHouse`
const ANIMATION_DELAY = (cov_1ezktp0oo().s[4]++, 0.45);
const drawRoof = (cov_1ezktp0oo().s[5]++, keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    stroke-dashoffset: ", ";\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n"])), OFF_SCREEN_OFFSET));
const drawHouse = (cov_1ezktp0oo().s[6]++, keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    stroke-dashoffset: ", ";\n  }\n  // draw line for first 85%\n  81.5% {\n    stroke-dashoffset: 0;\n  }\n  // 0.1 difference for immediate transition to hide bottom of home while roof\n  // is being drawn\n  81.6% {\n    stroke-dashoffset: ", ";\n  }\n"])), OFF_SCREEN_OFFSET, OFF_SCREEN_OFFSET));
cov_1ezktp0oo().s[7]++;
const HomeLoader = () => {
  cov_1ezktp0oo().f[0]++;
  cov_1ezktp0oo().s[8]++;
  return jsx("svg", {
    width: "128",
    height: "128",
    viewBox: "0 0 155 139",
    fill: "none"
  }, jsx("path", {
    d: "M4 61L78 6L150.5 61",
    stroke: colors.brand50,
    strokeWidth: STROKE_WIDTH,
    strokeLinecap: "round",
    css: /*#__PURE__*/css("stroke-dasharray:", SINGLE_STROKE, ";animation:", drawRoof, " ", ANIMATION_DURATION, "s linear forwards infinite;" + (process.env.NODE_ENV === "production" ? "" : ";label:HomeLoader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }), jsx("path", {
    d: "M133 68V135H95.3303L95 93.4307C95 93.4307 95.3303 77.781 77.7511 77.781C59.6697 77.781 59.6697 93.4307 59.6697 93.4307C59.6697 93.4307 59.8371 121.144 59.6697 135H22V68",
    stroke: colors.brand50,
    strokeWidth: STROKE_WIDTH,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    css: /*#__PURE__*/css("stroke-dasharray:", SINGLE_STROKE, ";stroke-dashoffset:", OFF_SCREEN_OFFSET, ";animation:", drawHouse, " ", ANIMATION_DURATION, "s ", ANIMATION_DELAY, "s linear forwards infinite;" + (process.env.NODE_ENV === "production" ? "" : ";label:HomeLoader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }));
};
export default HomeLoader;